import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import LockIcon from "@mui/icons-material/Lock";
import { Card, CardContent, Grid, Typography, styled } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useScoreData } from "../../score/context/ScoreProvider";
import { MapMainViewPoiProps } from "../Map";

export const MapMainViewPoi: FC<MapMainViewPoiProps> = ({
  children,
  path,
  x,
  y,
  color,
}) => {
  const { chapters } = useScoreData();

  const [isOver, setOver] = useState(false);
  const [isLocked, setIsLocked] = useState(true);
  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    const chapter = chapters.find(
      (chapter) => chapter.id === path.replace("/", "")
    );

    if (chapter) {
      setIsLocked(chapter.isLocked);
      setIsDone(chapter.isDone);
    }
  }, [chapters]);

  return (
    <Link
      to={!isLocked ? path : "#"}
      onMouseEnter={() => setOver(true)}
      onMouseLeave={() => setOver(false)}
    >
      <MapMainViewPoiContainer container flexWrap="wrap" {...{ x, y }}>
        <Grid
          item
          container
          xs={6}
          flexBasis={"fit-content"}
          justifyContent="center"
        >
          {isLocked ? (
            <LockIcon
              sx={(theme) => ({
                fontSize: 50,
                animation: isOver
                  ? "bounce 0.8s ease-in-out infinite both"
                  : "",
                "@keyframes bounce": {
                  "0%": {
                    transform: "scale(1) rotate(0deg)",
                  },
                  "50%": {
                    transform: "scale(1.2) rotate(5deg)",
                  },
                  "100%": {
                    transform: "scale(1) rotate(0deg)",
                  },
                },
              })}
              color={color}
            />
          ) : isDone ? (
            <CheckCircleIcon
              sx={(theme) => ({
                fontSize: 50,
              })}
              color={color}
            ></CheckCircleIcon>
          ) : (
            <FmdGoodIcon
              sx={(theme) => ({
                fontSize: 50,
                animation: "bounce 1s ease infinite both",
                "@keyframes bounce": {
                  "0%": {
                    transform: "scale(1)",
                  },
                  "80%": {
                    transform: "scale(1.2)",
                  },
                  "100%": {
                    transform: "scale(1)",
                  },
                },
              })}
              color={color}
            />
          )}
        </Grid>
        <Grid item justifyContent="center" minWidth="100%">
          <Card
            elevation={isOver && !isLocked ? 4 : 1}
            sx={{
              transform: `translateY(${isOver && !isLocked ? "-10px" : "0px"})`,
              transition: "transform 0.1s linear",
            }}
          >
            {!isLocked && (
              <CardContent sx={{ paddingBottom: "1em!important" }}>
                <Typography textAlign="center" fontSize="1em">
                  {children}
                </Typography>
              </CardContent>
            )}
          </Card>
        </Grid>
      </MapMainViewPoiContainer>
    </Link>
  );
};

const MapMainViewPoiContainer = styled(Grid)<{
  x: number;
  y: number;
}>(({ x, y }) => ({
  position: "absolute",
  left: `${x}%`,
  top: `${y}%`,
  height: "32%",
  width: "20%",
  display: "flex",
  alignContent: "space-between",
  justifyContent: "center",
}));
